import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const IDLE_LIMIT_MS = 60 * 60 * 1000; // 1 Stunde
const CHECK_INTERVAL_MS = 30 * 1000; // alle 30s prüfen
const ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "touchstart",
  "scroll",
  "click",
];

/**
 * Loggt den Nutzer automatisch aus, wenn 1 Stunde lang keine Aktivität
 * stattgefunden hat. Vergleicht die Wall-Clock-Zeit (robust gegen das
 * Throttling von Timern in Hintergrund-Tabs).
 */
export default function IdleTimeout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const lastActivityRef = useRef(Date.now());

  const doLogout = useCallback(async () => {
    await logout();
    navigate("/login");
    toast.message("Sie wurden wegen Inaktivität automatisch abgemeldet.");
  }, [logout, navigate]);

  useEffect(() => {
    if (!user) return undefined;

    lastActivityRef.current = Date.now();
    const markActivity = () => {
      lastActivityRef.current = Date.now();
    };

    ACTIVITY_EVENTS.forEach((e) =>
      window.addEventListener(e, markActivity, { passive: true })
    );

    const interval = setInterval(() => {
      if (Date.now() - lastActivityRef.current > IDLE_LIMIT_MS) {
        doLogout();
      }
    }, CHECK_INTERVAL_MS);

    return () => {
      ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, markActivity));
      clearInterval(interval);
    };
  }, [user, doLogout]);

  return null;
}
